export const VERSION = '1793798240414';
